import { initSurvey } from "../../store/survey/actions";
import store from "../../store";

export default function responderSurvey(conversationId, survey, active) {
  store.dispatch(initSurvey(conversationId, survey, active));
}
